/**
 * Área táctil de al menos 44×44 px sin cambiar lo que se ve: un `::after` invisible,
 * centrado sobre el control, que mide lo mismo que él o 44 px si el control es más chico.
 * El ícono, el borde y el fondo quedan iguales; solo crece la zona que recibe el toque.
 *
 * El control tiene que ser su propio bloque contenedor: sumá `relative` salvo que ya sea
 * `absolute`/`fixed`. Dejá al menos (44 − alto visible) / 2 px libres alrededor para que
 * dos áreas vecinas no se pisen, y no lo uses en controles con `overflow-hidden` (el
 * recorte también recorta el área).
 */
export const TOUCH_HIT_AREA =
  'after:absolute after:left-1/2 after:top-1/2 after:h-full after:min-h-11 after:w-full after:min-w-11 after:-translate-x-1/2 after:-translate-y-1/2';
